import { aPIPaths, handleResponse, requestTranslate } from '@redux/Config';

export const TranslationsService = {
    getTranslations,
    getCreateTranslation
};

function getTranslations(context, culture) {
    return requestTranslate(aPIPaths.get_Translations + context + "/" + culture).then(handleResponse);
}

function getCreateTranslation(context, culture, group, key) {
    return requestTranslate(aPIPaths.get_Translations_CreateTranslation + context + '/' + culture + '/' + group + '/' + key).then(handleResponse);
}